MH_SPOTLIGHT_COLLAPSED_KEY